import {fetchX} from '../../util/fetch';
import {objectToUrlParameters} from '../../util/url';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../api/api-const';

import {
    CalendarPublicationsRequestParametersType,
    CalendarPublicationsResponseType,
} from './publications-calendar-type';

// Deliberately uses the raw `fetchX` (like the posts calendar): the response is keyed by day/month
// and by snake_case status buckets, which key camelization would rewrite.
export function getPublicationsCalendar(
    parameters: CalendarPublicationsRequestParametersType,
    mainFilterKey: string
): Promise<CalendarPublicationsResponseType> {
    return fetchX<CalendarPublicationsResponseType>(
        `${rootApiUrl}/cp/publications/calendar/?` +
            objectToUrlParameters({
                ...parameters,
                filter_key: mainFilterKey,
            }),
        {
            headers: {...mainApiHeaders, ...getCsrfHeaders()},
        }
    );
}
